import React from "react";
import "../styles/pages/privacypolicy.css";
import SubHome from "../components/SubHome";

const PrivacyPolicy = () => {
  return (
    <>
      <SubHome mainHeading="Privacy & Policy" listItem="Privacy & Policy" />
      <div className="privacy-policy-container">
        <div
          className="heading-content-section"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2 className="main-heading">POLÍTICA DE PRIVACIDAD</h2>
          <div
            className="heading-border"
            style={{ marginBottom: "40px" }}
          ></div>
        </div>
        

        <h2>Tratamiento de datos personales</h2>
        <p>
          De conformidad con lo establecido en Reglamento (UE) 2016/679 del
          Parlamento Europeo y del Consejo de 27 de abril de 2016 (en adelante,
          “RGPD”), se informa que todos los datos personales que el Usuario
          facilite a través del Sitio Web www.cheffy.es (en adelante, el “Sitio
          Web”) gestionado por BESAFE con la finalidad de poder atender sus
          solicitudes y poder mantenerle informado, incluso por medios
          electrónicos, sobre nuestros productos y servicios.
        </p>
        <p>
          La cumplimentación de todos los datos solicitados a través del Sitio
          Web es necesaria para lograr una óptima prestación de los servicios
          puestos a disposición del Usuario. De no facilitarse todos los datos
          requeridos no se garantiza que la información y servicios facilitados
          puedan prestarse, se presten correctamente o se ajusten a las
          necesidades del Usuario.
        </p>
        <p>
          El término Usuario/s se emplea aquí para referirse a todas las
          personas que accedan al Sitio Web.
        </p>

        <h3>Información detallada sobre protección de datos personales</h3>
        <ol>
          <li>
            <h4>Responsable del tratamiento</h4>
            <p>
              Para cualquier cuestión, duda o aclaración relacionada con la
              presente Política de Privacidad o con el tratamiento de datos que
              se realiza, puede ponerse en contacto con nosotros a través de la
              dirección de correo electrónico cheffy@cheffy.es.
            </p>
          </li>
          <li>
            <h4>
              Información general: descripción de la información contenida en la
              política de privacidad
            </h4>
            <p>
              En la presente política de privacidad encontrará una tabla
              identificando, por cada uno de los diferentes tratamientos de
              datos realizados, la siguiente información:
            </p>
            <ul>
              <li>Las finalidades del tratamiento de sus datos personales.</li>
              <li>
                Las bases legales que permiten el tratamiento de sus datos para
                cada una de las finalidades indicadas.
              </li>
              <li>
                La posible comunicación de sus datos a terceros, así como la
                causa de dicha comunicación.
              </li>
              <li>
                La existencia de potenciales transferencias internacionales de
                datos.
              </li>
              <li>El plazo de conservación de los datos que nos facilite.</li>
            </ul>
          </li>
          <li>
            <h4>Información detallada de los tratamientos</h4>
            <p>
              A continuación, se detalla el tratamiento de datos personales que
              realizamos:
            </p>
            <table>
              <thead>
                <tr>
                  <th>FINALIDAD DEL TRATAMIENTO</th>
                  <th>BASE LEGAL</th>
                  <th>COMUNICACIÓN DE DATOS</th>
                  <th>PERIODO DE CONSERVACIÓN</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Gestionar las consultas planteadas a través del formulario
                    de contacto o correo electrónico.
                  </td>
                  <td>Interés legítimo.</td>
                  <td>No se ceden datos a terceros.</td>
                  <td>Hasta la resolución de la solicitud.</td>
                </tr>
                <tr>
                  <td>
                    Gestionar la compra de productos adquiridos a través del
                    sitio web.
                  </td>
                  <td>Ejecución del contrato.</td>
                  <td>
                    Colaboradores necesarios, Administraciones Públicas,
                    Tribunales, etc.
                  </td>
                  <td>
                    6 años en caso de relación comercial; de lo contrario, hasta
                    que se revoque el consentimiento.
                  </td>
                </tr>
                <tr>
                  <td>
                    Análisis estadísticos de visitas y comportamiento en la web.
                  </td>
                  <td>Consentimiento.</td>
                  <td>No se ceden datos a terceros.</td>
                  <td>Hasta que los datos sean obsoletos.</td>
                </tr>
                <tr>
                  <td>
                    Gestionar adecuadamente la navegación en el sitio web.
                  </td>
                  <td>Consentimiento.</td>
                  <td>No se ceden datos a terceros.</td>
                  <td>Hasta que los datos sean obsoletos.</td>
                </tr>
              </tbody>
            </table>
          </li>
          <li>
            <h4>Categoría de Datos</h4>
            <p>
              Atendiendo a las finalidades antes mencionadas, se tratan las
              siguientes categorías de datos:
            </p>
            <ul>
              <li>
                -Datos identificativos: nombre, apellidos, dirección de correo
                electrónico, dirección postal y teléfono cuando el Usuario se
                pone en contacto con cheffy .
              </li>
              <li>Datos de facturación: datos bancarios.</li>
              <li>
                -A través de las cookies recogemos determinada información
                vinculada a tu navegación. Su tratamiento y finalidades está
                explicado en nuestra política de cookies.
              </li>
            </ul>
            <p>
              Al facilitarnos sus datos por correo electrónico, formularios
              on-line u off-line o por cualquier otro medio, el Usuario
              garantiza que éstos son verdaderos, exactos, completos y
              actualizados, responsabilizándose de cualquier daño o perjuicio,
              directo o indirecto, que pudiera ocasionarse como consecuencia del
              incumplimiento de tal obligación. En caso de que facilite a Cheffy
              datos de terceros, el Usuario debe contar con el consentimiento de
              los mismos y comprometerse a trasladarles la información contenida
              en esta cláusula, eximiendo a Cheffy de cualquier responsabilidad
              en este sentido. No obstante, Cheffy podrá llevar a cabo las
              verificaciones para constatar este hecho, adoptando las medidas de
              diligencia debida que correspondan, conforme a la normativa de
              protección de datos.
            </p>
          </li>
          <li>
            <h4>Menores de Edad</h4>

            <p>
              Los menores de edad no podrán usar los servicios disponibles a
              través del Sitio Web sin la previa autorización de sus padres,
              madres, tutores o representantes legales, quienes serán los únicos
              responsables de todos los actos realizados a través del Sitio Web
              por los menores a su cargo, incluyendo la cumplimentación de los
              formularios con los datos personales de dichos menores y la
              marcación, en su caso, de las casillas que los acompañan.
            </p>
          </li>
          <li>
            <h4>Ejercicio de derechos</h4>
            <p>
              El Usuario podrá ejercer los siguientes derechos, previstos en el
              RGPD, en relación al tratamiento de sus datos personales:
            </p>
            <ul>
              <li>Derecho a solicitar su rectificación.</li>
              <li>Derecho a solicitar su supresión.</li>
              <li>Derecho a solicitar la limitación de su tratamiento.</li>
              <li>Derecho a oponerse al tratamiento.</li>
              <li>Derecho a la portabilidad de los datos.</li>
              <li>
                Derecho a no ser objeto de decisiones individuales
                automatizadas.
              </li>
            </ul>
            <p>
              Tales derechos podrán ser ejercidos mediante una comunicación
              escrita dirigida por e-mail a la direccióncheffy@cheffy.es . El
              Usuario interesado deberá acompañar una copia de su documento
              nacional de identidad, pasaporte u otro documento válido que lo
              identifique en el caso que se considere necesaria su
              identificación. Cheffy procederá a enviarle una comunicación
              dentro del plazo de un mes desde la recepción de la solicitud,
              juntamente, en su caso, con otras informaciones que puedan ser
              relevantes para resolver la solicitud. Asimismo, podrá presentar
              una reclamación ante la Agencia Española de Protección de Datos si
              lo estima oportuno.
            </p>
          </li>
          <li>
            <h4>Medidas y niveles de seguridad</h4>

            <p>
              Se adoptan los niveles de seguridad requeridos por el RGPD
              adecuados a la naturaleza de los datos que son objeto de
              tratamiento en cada momento. No obstante lo anterior, la seguridad
              técnica en un medio como Internet no es inexpugnable y pueden
              existir actuaciones dolosas de terceros, si bien Cheffy pone todos
              los medios a su alcance para evitar dichas actuaciones.
            </p>
          </li>
          <li>
            <h4>Transferencia internacional de datos</h4>

            <p>
              No cedemos los datos personales del Usuario a terceros fuera del
              Espacio Económico Europeo. En el caso de realizarse transferencias
              internacionales de datos, se tomarán todas las medidas técnicas y
              organizativas adecuadas para garantizar la seguridad de los datos.
            </p>
          </li>
          <li>
            <h4> Confidencialidad y secreto profesional</h4>
            <ul>
              <li>
                <p>
                  Los datos recogidos en todas las comunicaciones privadas entre
                  Cheffy y los clientes o Usuarios serán tratados con absoluta
                  confidencialidad, comprometiéndonos a la obligación de secreto
                  de los datos de carácter personal, a su deber de guardarlos y
                  adoptar todas las medidas necesarias que eviten su alteración,
                  pérdida y tratamiento o acceso no autorizado, de acuerdo con
                  lo establecido en la normativa de protección de datos
                  aplicable.
                </p>
              </li>
              <li>
                <p>
                  Además, también tendrá la condición de confidencial la
                  información de cualquier tipo que las partes intercambien
                  entre sí, aquella que estas acuerden que tiene tal naturaleza,
                  o la que simplemente verse sobre el contenido de dicha
                  información. La visualización de datos a través de Internet no
                  supondrá el acceso directo a los mismos, salvo consentimiento
                  expreso de su titular para cada ocasión.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h4>
              {" "}
              Cambios en la política de seguridad y de protección de datos
            </h4>

            <p>
              Cheffy se reserva el derecho de modificar su política de seguridad
              y protección de datos con el objeto de adaptarlo a las novedades
              legislativas o jurisprudenciales, así como las que pudieran
              derivarse de códigos tipo existentes en la materia, o por
              decisiones corporativas estratégicas, con efectos de la fecha de
              publicación de dicha modificación en el Sitio Web.
            </p>
          </li>
          <li>
            <h4> Enlaces a otros sitios web</h4>

            <ul>
              <li>
                <p>
                  Con relación a los enlaces o vínculos que con otros portales o
                  páginas web, no gestionadas por Cheffy puedan aparecer en el
                  portal a título informativo, Cheffy no ejerce ningún control
                  sobre los mismos, ni responde de la información a la que se
                  acceda. Salvo que Cheffy así lo hubiera autorizado de forma
                  previa y por escrito, no se podrá insertar un link, hyperlink,
                  framing o vínculo similar en el Sitio Web.
                </p>
              </li>
              <li>
                <p>
                  En el caso de seguirnos en redes sociales como Twitter, revise
                  sus políticas de privacidad para informarse de cómo se
                  utilizan y comparten sus datos personales, ya que Cheffy
                  tampoco ejerce ningún control sobre los mismos ni responde de
                  la información a la que se accede.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h4>Cookies</h4>

            <ul>
              <li>
                <p>
                El acceso a esta web puede implicar la utilización de cookies. Las cookies son pequeñas cantidades de información que se almacenan en el navegador utilizado por cada usuario para que el servidor recuerde cierta información que posteriormente pueda utilizar. Esta información permite identificarle a usted como un usuario concreto y permite guardar sus preferencias personales, así como información técnica como puedan ser visitas o páginas concretas que visite.
                </p>
              </li>
              <li>
                <p>
                Aquellos usuarios que no deseen recibir cookies o quieran ser informados antes de que se almacenen en su ordenador, pueden configurar su navegador a tal efecto. Para más información consulte nuestra “Política de Cookies”.
                </p>
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </>
  );
};

export default PrivacyPolicy;
